import { getAppEventName } from '../../../utils/services/googleAnalytics'
import { formatNumber } from '../../../utils/utils'
import { appConfig } from './constants'
import { handleDataLayerEvent, handleGAEvent } from './googleAnalytics'

const stateNameDict = {
  subApp: { display: 'subApp' },
  insertType: { display: 'Insert' },
  insertDiameter: { display: 'Insert Diameter' },
  adhesiveAnchor: { display: 'Adhesive Anchor' },
  drillBitDiameter: { display: 'Drill Bit Diameter' },
  embedmentDepth: { display: 'Embedment Depth' },
  screenTube: { display: 'Screen Tube' },
  numberInstallations: { display: 'Number Installations' },
  overageFactor: { display: 'Overage Factor' },
  waterFilledHoles: { display: 'Water Filled Holes' },
}

export const displayValueDict = {
  subApp: {
    0: { display: 'Threaded Rod and Rebar Doweling' },
    1: { display: 'Crack Injection' },
  },
  insertDiameter: {
    '.375': { display: '3/8"' },
    '.5': { display: '1/2"' },
    '.625': { display: '5/8"' },
    '.75': { display: '3/4"' },
    '.875': { display: '7/8"' },
    1: { display: '1"' },
    1.125: { display: '1 1/8"' },
    1.25: { display: '1 1/4"' },
    1.375: { display: '1 3/8"' },
    '10M': { display: '10M' },
    '15M': { display: '15M' },
    '20M': { display: '20M' },
    '25M': { display: '25M' },
    '30M': { display: '30M' },
  },
  drillBitDiameter: {
    '.4375': { display: '7/16"' },
    '.5': { display: '1/2"' },
    '.5625': { display: '9/16"' },
    '.625': { display: '5/8"' },
    '.6875': { display: '11/16"' },
    '.75': { display: '3/4"' },
    '.8125': { display: '13/16"' },
    '.875': { display: '7/8"' },
    '.9375': { display: '15/16"' },
    1: { display: '1"' },
    1.0625: { display: '1 1/16"' },
    1.125: { display: '1 1/8"' },
    1.1875: { display: '1 3/16"' },
    1.25: { display: '1 1/4"' },
    1.3125: { display: '1 5/16"' },
    1.375: { display: '1 3/8"' },
    1.4375: { display: '1 7/16"' },
    1.5: { display: '1 1/2"' },
    1.5625: { display: '1 9/16"' },
    1.625: { display: '1 5/8"' },
    1.6875: { display: '1 11/16"' },
    1.75: { display: '1 3/4"' },
    1.8125: { display: '1 13/16"' },
    1.875: { display: '1 7/8"' },
    14: { display: '14MM' },
    20: { display: '20MM' },
    25: { display: '25MM' },
    32: { display: '32MM' },
    40: { display: '40MM' },
  },
  waterFilledHoles: {
    false: { display: 'No' },
    true: { display: 'Yes' },
  },
  crackWidth: {
    '.01560': { display: '< 1/64"' },
    '.0156': { display: '1/64"' },
    '.0313': { display: '1/32"' },
    '.0625': { display: '1/16"' },
    '.0938': { display: '3/32"' },
    '.125': { display: '1/8"' },
    '.1875': { display: '3/16"' },
    '.25': { display: '1/4"' },
  },
}
/*
<div class="prettyPrint">
  <span class="prettyPrintOutputPair">
    <span class="prettyPrintOutputLabel">Insert</span>: Threaded Rod,
  </span>
  <span class="prettyPrintOutputPair">
    <span class="prettyPrintOutputLabel">Insert Diameter</span>: 5/8",
  </span>
  .............
</div>
*/
export const convertUserInputToDisplayFormat = (userInputs) => {
  if (!userInputs) {
    return ''
  }

  const obj = userInputs

  const myUserInputDisplay = Object.keys(obj).reduce((result, key, index) => {
    const myValue = obj[key]

    // console.log(key, myValue, index)

    if (
      myValue == undefined ||
      key === 'subApp' ||
      key === 'source' ||
      key === 'sourceDomain' ||
      key === 'adhesiveAnchorModel' ||
      key === 'validation' ||
      key === 'jobList'
    ) {
      return result
    }
    const displayKey = stateNameDict[key].display

    const myDict = displayValueDict[key]

    // console.log(key, displayKey, myValue, myDict)

    let displayValue =
      myDict && myDict[myValue] && myDict[myValue].display ? myDict[myValue].display : myValue

    // displayValue = (key === 'screenTube') ? myValue.split('_')[0] : displayValue
    displayValue = key === 'overageFactor' ? parseFloat(myValue) * 100 + '%' : displayValue
    displayValue = key === 'numberInstallations' ? formatNumber(displayValue) : displayValue

    let x =
      '<span class="prettyPrintOutputPair"><span class="prettyPrintOutputLabel">' +
      displayKey +
      '</span>: ' +
      displayValue +
      (key === 'embedmentDepth' ? '"' : '')
    x = index > 0 ? ', </span>' + x : x

    return result + x
  }, '')

  return myUserInputDisplay
}

export const useColumnsCI = () => {
  const handleAnchorClick = (e, row, source) => {
    const x = row.row.original

    const editedInput = Object.assign(
      {},
      {
        injectResin: x.injectionResin,
        pasteOverEpoxy: x.pasteOverEpoxy,
      },
      x.pumpingPortStyle ? { pumpingPortStyle: x.pumpingPortStyle } : null,
      {
        linkNameClicked: e.target.name,
      },
    )
    let appEventName = getAppEventName(appConfig.appCode, source === 'EC' )
    handleGAEvent({
      appEventName,
      gaActionName: 'Click_Link_Action',
      gaLabelName: 'Click_Related_Product_Link',
      input: editedInput,
    })

    handleDataLayerEvent({
      appEventName,
      appAction: 'Click_Link_Action',
      appInputs: editedInput.linkNameClicked
    })
  }

  const headerInjectionResin = [
    {
      //   Header: 'Model',
      //   accessor: 'model',
      //   Cell: row => (
      //     <>
      //       <OrderCheckbox {...row.row.original} />
      //       <a name={row.cell.value} href={row.row.original.productUrl || 'TBD'} target='_blank'
      //         onClick={(e) => handleAnchorClick(e, row)}>
      //         {row.cell.value}
      //       </a>
      //     </>
      //   )
      // }, {
      Header: 'Package Size',
      accessor: (d) => {
        return d.cartridgeVolumeInGallon > 1.0
          ? d.cartridgeVolumeInGallon + ' Gallons (' + d.cartridgeVolume + ' oz)'
          : d.cartridgeVolume + ' oz'
      },
    },
    {
      Header: 'Quantity',
      accessor: (d) => {
        return d.cartridgesNeeded.toFixed(2)
      },
    },
    {
      Header: 'Packaging Type',
      accessor: 'packagingType',
    },
    {
      Header: 'Overage Factor',
      accessor: (d) => {
        return (d.overageFactor * 100).toString() + '%'
      },
    },
  ]

  const headerPasteOverEpoxy = [
    {
      //   Header: 'Model',
      //   accessor: 'model',
      //   Cell: row => (
      //     <a name={row.cell.value} href={row.row.original.productUrl || 'TBD'} target='_blank'
      //       onClick={(e) => handleAnchorClick(e, row)}>
      //       {row.cell.value}
      //     </a>
      //   )
      // }, {
      Header: 'Package Size',
      accessor: (d) => {
        return d.cartridgeVolumeInGallon > 1.0
          ? d.cartridgeVolumeInGallon + ' Gallons (' + d.cartridgeVolume + ' oz)'
          : d.cartridgeVolume + ' oz'
      },
    },
    {
      Header: 'Quantity',
      accessor: (d) => {
        return d.cartridgesNeeded.toFixed(2)
      },
    },
    {
      Header: 'Overage Factor',
      accessor: 'overageFactor',
      accessor: (d) => {
        return (d.overageFactor * 100).toString() + '%'
      },
    },
  ]

  const headerPumpingPorts = [
    {
      //   Header: 'Model',
      //   accessor: 'model',
      //   Cell: row => (
      //     <a name={row.cell.value} href={row.row.original.productUrl || 'TBD'} target='_blank'
      //       onClick={(e) => handleAnchorClick(e, row)}>
      //       {row.cell.value}
      //     </a>
      //   )
      // }, {
      Header: 'Package Size',
      accessor: 'packageSize',
    },
    {
      Header: 'Quantity',
      accessor: (d) => {
        if (d.packageSize === '1') {
          return Math.round(d.packagesNeeded)
        } else {
          return d.packagesNeeded.toFixed(2)
        }
      },
    },
    {
      Header: 'Pumping-Port Style',
      accessor: 'pumpingPortStyle',
    },
  ]

  const headerInjectionFittings = [
    {
      //   Header: 'Model',
      //   accessor: 'model',
      //   Cell: row => (
      //     <a name={row.cell.value} href={row.row.original.productUrl || 'TBD'} target='_blank'
      //       onClick={(e) => handleAnchorClick(e, row)}>
      //       {row.cell.value}
      //     </a>
      //   )
      // }, {
      Header: 'Package Size',
      accessor: 'packageSize',
    },
    {
      Header: 'Quantity',
      accessor: (d) => {
        return 'Minimum 1'
      },
    },
  ]

  return {
    handleAnchorClick,
    headerInjectionResin,
    headerPasteOverEpoxy,
    headerPumpingPorts,
    headerInjectionFittings,
  }
}
